import { render } from "./AdultsTable.vue?vue&type=template&id=67aec130"
import script from "./AdultsTable.vue?vue&type=script&lang=js"
export * from "./AdultsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__